module.exports = __webpack_public_path__ + "img/168.abfd1a5e.jpg";